module.exports = __webpack_public_path__ + "images/emoji/dancer.c10be35415d8199f89f9.png";